import { ProductKey } from "../enums/ProductKey";


export const SERVICE_ICONS: Record<ProductKey, string> = {

  // TRANSFER
  [ProductKey.Collect]: "/assets/service-icons/collect.webp",
  [ProductKey.Transfer]: "/assets/service-icons/transfer.webp",
  [ProductKey.Transit]: "/assets/service-icons/intern_transit.webp",
  [ProductKey.VehicleStorageExit]: "",
  [ProductKey.Return]: "/assets/service-icons/return.webp",
  [ProductKey.MediumLongDistance]: "/assets/service-icons/long_distance_tranfer.webp",

  // BASIC REPLACEMENT

  [ProductKey.ReplacementVehicleTransfer]: "/assets/service-icons/replacement_vehicle.webp",

  // MAINTENANCE

  [ProductKey.TireCheck]: "/assets/service-icons/tyres.webp",
  [ProductKey.CaflerReady]: "/assets/service-icons/fine_tunning.webp",
  [ProductKey.MotorbikeBasicMaintenance]: "/assets/service-icons/maintenance_pack.webp",
  [ProductKey.MotorbikeCompleteMaintenance]: "/assets/service-icons/maintenance_pack.webp",
  [ProductKey.CarBasicMaintenance]: "/assets/service-icons/maintenance_pack.webp",
  [ProductKey.CarCompleteMaintenance]: "/assets/service-icons/maintenance_pack.webp",
  [ProductKey.CarMediumMaintenance]: "/assets/service-icons/maintenance_pack.webp",
  [ProductKey.WorkshopAtHome]: "/assets/service-icons/diagnostic.webp",
  [ProductKey.Tyres]: "/assets/service-icons/tyres.webp",
  [ProductKey.ChecklistTopping]: "/assets/service-icons/checkList.webp",

  // CLEAN UP

  [ProductKey.CaflerCompleteAtvWash]: "/assets/service-icons/complete-car-wash-topping_icon.webp",
  [ProductKey.IntegralWashing]: "/assets/service-icons/integral-washing_icon.webp",
  [ProductKey.HeadlightPolishing]: "/assets/service-icons/headlight-polishing_icon.webp",
  [ProductKey.TunnelCompleteCarWash]: "/assets/service-icons/tunnel-complete-car-wash_icon.webp",
  [ProductKey.TunnelWash]: "/assets/service-icons/tunnel-complete-car-wash_icon.webp",
  [ProductKey.Upholstery5Seats]: "/assets/service-icons/upholstery-detail-wash-5-seats_icon.webp",
  [ProductKey.MotorbikeWash]: "/assets/service-icons/tunnel-complete-car-wash_icon.webp",
  [ProductKey.BasicTunnelCarWash]: "/assets/service-icons/tunnel-complete-car-wash_icon.webp",

  // Refueling

  [ProductKey.Refueling]: "/assets/service-icons/refueling.webp",
  [ProductKey.RefuelingTopping]: "/assets/service-icons/refueling.webp",

  // ITV

  [ProductKey.PreMOT]: "/assets/service-icons/pre_itv.webp",
  [ProductKey.PreMot360]: "/assets/service-icons/pre_itv.webp",
  [ProductKey.MotDieselCarEs]: "/assets/service-icons/itv_ES.webp",
  [ProductKey.MotDieselCarFr]: "/assets/service-icons/itv_FR.webp",
  [ProductKey.MotDieselVanEs]: "/assets/service-icons/itv_ES.webp",
  [ProductKey.MotElectricCarEs]: "/assets/service-icons/itv_ES.webp",
  [ProductKey.MotElectricCarFr]: "/assets/service-icons/itv_FR.webp",
  [ProductKey.MotElectricVanEs]: "/assets/service-icons/itv_ES.webp",
  [ProductKey.MotFuelCarEs]: "/assets/service-icons/itv_ES.webp",
  [ProductKey.MotFuelCarFr]: "/assets/service-icons/itv_FR.webp",
  [ProductKey.MotFuelCarUk]: "/assets/service-icons/itv_UK.webp",
  [ProductKey.MotGasCarFr]: "/assets/service-icons/itv_FR.webp",
  [ProductKey.MotGasVanEs]: "/assets/service-icons/itv_ES.webp",
  [ProductKey.MotHomologation]: "/assets/service-icons/itv_homologation.webp",
  [ProductKey.MotHybridCarEs]: "/assets/service-icons/itv_ES.webp",
  [ProductKey.MotHybridCarFr]: "/assets/service-icons/itv_FR.webp",
  [ProductKey.MotHybridVanEs]: "/assets/service-icons/itv_ES.webp",
  [ProductKey.MotMotorbike125Es]: "/assets/service-icons/itv_ES.webp",
  [ProductKey.MotMotorbikeEs]: "/assets/service-icons/itv_ES.webp",
  [ProductKey.MotMotorbikeUk]: "/assets/service-icons/itv_UK.webp",
  [ProductKey.MotElectricMotorbike125]: "/assets/service-icons/itv_ES.webp",
  [ProductKey.MotElectricMotorbikePlus125]: "/assets/service-icons/itv_ES.webp",

  // INSURACE

  [ProductKey.InsuranceTopping]: "/assets/service-icons/insurance.webp",
  [ProductKey.CaflerFreshAtvTopping]: "",

  // PARKING

  [ProductKey.ValetTrainStation]: "/assets/service-icons/valet.webp",
  [ProductKey.Parking]: "/assets/service-icons/parking.webp",

  // FORMALITIES

  [ProductKey.OwnershipChange]: "/assets/service-icons/change_name.webp",

  // ASSISTANCE

  [ProductKey.TowTruck]: "/assets/service-icons/tow_truck.webp",

  // OTHER

  [ProductKey.VehicleStorage]: "/assets/service-icons/campa.svg",

  // New Added From Front (Products Group)

  [ProductKey.TechnicalInspection]: "/assets/service-icons/itv_ES.webp",
  [ProductKey.SpecializedCenter]: "/assets/service-icons/wash.webp",
  [ProductKey.MaintenancePack]: "/assets/service-icons/maintenance_pack.webp",
  [ProductKey.WhatYouWant]: "/assets/service-icons/what_you_want.webp"

}